import { defineComponent as be, ref as I, computed as s, watch as xe, createElementBlock as O, openBlock as f, createVNode as h, createCommentVNode as T, unref as m, withCtx as u, withDirectives as ge, createBlock as V, vShow as ke, mergeProps as F, normalizeClass as we, createElementVNode as G, toDisplayString as x, createTextVNode as M, nextTick as Ie } from "vue";
import "@popperjs/core";
import { RevDrawer as Te } from "@ds/components/Drawer";
import z from "../InputSelect/components/InputSelectButton.vue2.js";
import { RevInputText as ye } from "@ds/components/InputText";
import { RevLink as Ce } from "@ds/components/Link";
import { RevPopover as Ee } from "@ds/components/Popover";
import Oe from "../../icons/generated/IconSearch.vue2.js";
import { useI18n as Ve } from "@ds/plugin";
import Pe from "../../translations/generic.translations.js";
import { isEmpty as Be } from "../../utils/isEmpty.js";
import { scrollToElement as Ae } from "../../utils/scrollToElement.js";
import { tw as H } from "../../utils/tailwind.js";
import "@ds/components/Backdrop";
import "@ds/components/ButtonIcon";
import "@ds/components/Portal";
import "@ds/components/Icon";
import { openModal as Se, closeModal as j } from "../ModalBase/ModalBase.helpers.js";
import { defaultScrollToElementTimeout as De, LIST_ITEM_HEIGHT_WITH_DESCRIPTION as Me, LIST_ITEM_HEIGHT as He, SEARCH_ITEM_HEIGHT as Le, MARGIN as Q, NO_ACTIVE_OPTION as L } from "./InputSelectSearchable.constant.js";
import { isOptionsGroup as Ne } from "./InputSelectSearchable.helpers.js";
import W from "./components/InputSelectSearchableOptionsList.vue2.js";
import J from "./components/InputSelectSearchableSearch.vue2.js";
const $e = { class: "relative" }, Ue = {
  key: 0,
  class: "relative flex items-center"
}, Re = { class: "pl-12 pr-32 pt-20" }, qe = {
  key: 0,
  class: "md:hidden"
}, Ke = { class: "pl-12 pr-32 pt-20" }, Fe = ["id"], N = "input-select-searchable-mobile-drawer", mt = /* @__PURE__ */ be({
  name: "RevInputSelectSearchable",
  __name: "InputSelectSearchable",
  props: {
    clearButtonAriaLabel: {},
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hideCheckboxes: { type: Boolean, default: !1 },
    id: {},
    label: {},
    listboxPlacement: { default: "auto" },
    modelValue: {},
    modifiers: { default: () => [] },
    noOptionsMessage: {},
    defaultOption: { default: void 0 },
    options: {},
    scrollToElementTimeout: { default: De },
    searchPlacement: { default: "field" },
    searchPlaceholder: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["text-change", "update:modelValue", "focus", "clear"],
  setup(l, { emit: X }) {
    const i = l, y = X, Y = Ve(), p = I(""), C = I(!1), b = s(() => i.searchPlacement === "dropdown"), Z = s(() => {
      if (i.options.length < 6)
        return "";
      const e = i.options.slice(0, 6), t = (n) => n.description ? Me : He, o = e.reduce(
        (n, v) => n + t(v),
        0
      ), a = b.value ? Le + Q : Q;
      return `${o + a}px`;
    }), _ = s(() => [
      {
        name: "flip",
        options: {
          allowedAutoPlacements: ["top", "bottom"]
        }
      },
      ...i.modifiers
    ]), r = I(L), P = I(!1), g = s(
      () => i.options.reduce(
        (e, t) => e.concat(Ne(t) ? t.options : t),
        []
      )
    ), B = s(
      () => Object.fromEntries(g.value.map(({ id: e }, t) => [e, t]))
    ), d = s({
      get() {
        return i.modelValue;
      },
      set(e) {
        y("update:modelValue", e);
      }
    }), k = s(() => `${i.id}-listbox`);
    function A(e = !0) {
      return e ? g.value[r.value]?.id : void 0;
    }
    function S() {
      return d.value ? d.value.label : "";
    }
    const w = I(S());
    function E(e) {
      w.value = e, p.value = "", y("text-change", e);
    }
    function ee(e, t) {
      t(), y("focus", e);
    }
    function te() {
      C.value = !0;
    }
    function oe() {
      C.value = !1;
    }
    xe(d, (e) => {
      E(e ? e.label : "");
    });
    function le(e) {
      P.value || (E(S()), e());
    }
    const ae = s(
      () => i.options.filter(
        (e) => e.label.toLowerCase().includes(p.value.toLowerCase())
      )
    ), $ = s(() => {
      const e = d.value, t = ae.value;
      return b.value && e ? [e, ...t.filter((o) => o.id !== e.id)] : t;
    });
    function ne(e, t, o) {
      e ? t() : o();
    }
    function ie(e, t, o) {
      r.value = L, e || t(), E(o ? o.toString() : "");
    }
    function U(e) {
      d.value = null, e(), y("clear");
    }
    function D(e) {
      return d.value ? e.id === d.value.id : !1;
    }
    async function R(e) {
      d.value = D(e) ? null : e, await Ie(), E(S());
    }
    function re(e, t, o, a) {
      if (e.preventDefault(), !A(a)) {
        t();
        return;
      }
      o(), R(g.value[r.value]);
    }
    function se(e, t) {
      e.currentTarget.blur(), t();
    }
    function ce(e, t, o) {
      if (Be(g.value))
        return;
      if (e.preventDefault(), !o) {
        t();
        return;
      }
      const { length: a } = g.value;
      switch (e.key) {
        case "PageUp":
        case "Home":
          r.value = 0;
          break;
        case "PageDown":
        case "End":
          r.value = a - 1;
          break;
        // ArrowUp or ArrowDown
        default:
          if (r.value === L)
            r.value = e.key === "ArrowUp" ? a - 1 : 0;
          else {
            const c = { ArrowUp: -1, ArrowDown: 1 }[e.key];
            r.value = (r.value + a + c) % a;
          }
      }
      const n = String(A()), v = document.getElementById(n);
      v && Ae(v, {
        timeout: i.scrollToElementTimeout,
        scroll: { behavior: "instant", block: "nearest" }
      });
    }
    function q(e, t, o, a) {
      switch (e.key) {
        case "Enter":
          re(e, t, o, a);
          break;
        case "Escape":
          se(e, o);
          break;
        case "ArrowDown":
        case "PageDown":
        case "End":
        case "ArrowUp":
        case "PageUp":
        case "Home":
          ce(e, t, a);
          break;
      }
    }
    function de(e) {
      r.value = B.value[e.id];
    }
    function ue() {
      P.value = !0;
    }
    function me(e, t, o) {
      e.preventDefault(), P.value = !1, o(), R(t);
    }
    function K(e, t) {
      return {
        mousemove: () => de(e),
        mousedown: () => ue(),
        click: (o) => me(o, e, t)
      };
    }
    function fe() {
      U(() => j(N));
    }
    const ve = s(() => [
      i.error && H`border-action-danger-low focus-visible:border-action-danger-low-focus focus-visible:outline-danger-low`
    ]), he = s(() => [
      H`text-action-default-hi pointer-events-none absolute right-12 shrink-0 select-none`,
      i.disabled && H`text-static-default-low-disabled`
    ]), pe = s(() => `${i.id}_error`);
    return (e, t) => (f(), O("div", $e, [
      h(m(Ee), {
        "content-class-names": "z-10 w-full",
        modifiers: _.value,
        position: l.listboxPlacement
      }, {
        trigger: u(({ show: o, hide: a, isOpen: n, ...v }) => [
          b.value ? (f(), V(z, F({
            key: 1,
            id: l.id
          }, v, {
            "aria-controls": k.value,
            "aria-expanded": n,
            class: "hidden md:flex",
            disabled: l.disabled,
            focused: C.value,
            "has-error": !!l.error,
            "has-selected-option": !!w.value,
            required: l.required,
            role: "combobox",
            "select-id": l.id,
            onBlur: oe,
            onClick: () => ne(n, a, o),
            onFocus: te,
            onKeydown: (c) => q(c, o, a, n)
          }), {
            label: u(() => [
              M(x(l.label), 1)
            ]),
            value: u(() => [
              G("div", Re, x(d.value?.label), 1)
            ]),
            _: 1
          }, 16, ["id", "aria-controls", "aria-expanded", "disabled", "focused", "has-error", "has-selected-option", "required", "select-id", "onClick", "onKeydown"])) : (f(), O("div", Ue, [
            h(m(ye), F({ id: l.id }, v, {
              "aria-activedescendant": A(n),
              "aria-autocomplete": "list",
              "aria-controls": k.value,
              "aria-expanded": String(n),
              autocomplete: "off",
              class: "w-full",
              "clear-button-aria-label": l.clearButtonAriaLabel,
              disabled: l.disabled,
              "input-class": ve.value,
              label: l.label,
              "model-value": w.value,
              role: "combobox",
              onBlur: (c) => le(a),
              onClear: (c) => U(a),
              onFocus: (c) => ee(c, o),
              onKeydown: (c) => q(c, o, a, n),
              "onUpdate:modelValue": (c) => ie(n, o, c)
            }), null, 16, ["id", "aria-activedescendant", "aria-controls", "aria-expanded", "clear-button-aria-label", "disabled", "input-class", "label", "model-value", "onBlur", "onClear", "onFocus", "onKeydown", "onUpdate:modelValue"]),
            w.value ? T("", !0) : (f(), V(m(Oe), {
              key: 0,
              class: we(he.value),
              size: "20"
            }, null, 8, ["class"]))
          ]))
        ]),
        content: u(({ isOpen: o, hide: a }) => [
          ge(h(W, {
            "active-option-index": r.value,
            class: "mt-8",
            "default-option": l.defaultOption,
            "flat-option-indexes": B.value,
            "get-list-item-listeners": K,
            hide: a,
            "hide-checkbox": i.hideCheckboxes,
            "is-option-selected": D,
            "list-id": k.value,
            "max-height": Z.value,
            "no-options-message": l.noOptionsMessage,
            options: $.value,
            "search-placement": l.searchPlacement,
            view: "desktop"
          }, {
            search: u(() => [
              b.value ? (f(), V(J, {
                key: 0,
                modelValue: p.value,
                "onUpdate:modelValue": t[0] || (t[0] = (n) => p.value = n),
                "search-placeholder": l.searchPlaceholder
              }, null, 8, ["modelValue", "search-placeholder"])) : T("", !0)
            ]),
            _: 1
          }, 8, ["active-option-index", "default-option", "flat-option-indexes", "hide", "hide-checkbox", "list-id", "max-height", "no-options-message", "options", "search-placement"]), [
            [ke, o]
          ])
        ]),
        _: 1
      }, 8, ["modifiers", "position"]),
      b.value ? (f(), O("div", qe, [
        h(z, {
          id: l.id,
          "aria-owns": k.value,
          disabled: l.disabled,
          focused: C.value,
          "has-error": !!l.error,
          "has-selected-option": !!w.value,
          required: l.required,
          role: "combobox",
          "select-id": l.id,
          onClick: t[1] || (t[1] = (o) => m(Se)(N))
        }, {
          label: u(() => [
            M(x(l.label), 1)
          ]),
          value: u(() => [
            G("div", Ke, x(d.value?.label), 1)
          ]),
          _: 1
        }, 8, ["id", "aria-owns", "disabled", "focused", "has-error", "has-selected-option", "required", "select-id"]),
        h(m(Te), {
          "has-padding": !1,
          name: "input-select-searchable-mobile-drawer",
          title: l.label
        }, {
          beforeTitle: u(() => [
            h(m(Ce), { onClick: fe }, {
              default: u(() => [
                M(x(m(Y)(m(Pe).buttonClear)), 1)
              ]),
              _: 1
            })
          ]),
          body: u(() => [
            b.value ? (f(), V(J, {
              key: 0,
              modelValue: p.value,
              "onUpdate:modelValue": t[2] || (t[2] = (o) => p.value = o),
              class: "border-static-default-low border-b-1",
              "search-placeholder": l.searchPlaceholder
            }, null, 8, ["modelValue", "search-placeholder"])) : T("", !0),
            h(W, {
              "active-option-index": r.value,
              class: "rounded-none",
              "default-option": l.defaultOption,
              "flat-option-indexes": B.value,
              "get-list-item-listeners": K,
              hide: () => m(j)(N),
              "hide-checkbox": i.hideCheckboxes,
              "is-option-selected": D,
              "list-id": k.value,
              "no-options-message": l.noOptionsMessage,
              options: $.value,
              "search-placement": l.searchPlacement,
              view: "mobile"
            }, null, 8, ["active-option-index", "default-option", "flat-option-indexes", "hide", "hide-checkbox", "list-id", "no-options-message", "options", "search-placement"])
          ]),
          _: 1
        }, 8, ["title"])
      ])) : T("", !0),
      l.error ? (f(), O("p", {
        key: 1,
        id: pe.value,
        class: "text-static-danger-hi body-2 mt-8",
        role: "alert"
      }, x(l.error), 9, Fe)) : T("", !0)
    ]));
  }
});
export {
  mt as default
};
